<form [formGroup]="formGroup">
  <tui-text-area
    [formControlName]="formControlName"
    [tuiTextfieldSize]="size"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [expandable]="properties?.expandable ?? true"
    [readOnly]="properties?.readOnly ?? false"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <textarea
      tuiTextfield
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    ></textarea>
  </tui-text-area>
</form>
